export default __webpack_public_path__ + "static/media/cw.40e4f500.svg";